import axios from 'axios'
import { Message, Loading } from 'element-ui'
import store from '@/store'
import Vue from 'vue';
let loading = null

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

service.interceptors.request.use(config => {
//loading = Loading.service({
//  lock: true,
//  text: '加载中...',
//  background: 'rgba(0,0,0,0.3)'
//})

  if (store.getters.token) {
    config.headers.Authorization = 'Bearer ' + store.getters.token
  }
  return config
})

service.interceptors.response.use(res => {
  if(loading) loading?.close()
  return res
}, err => {
  if(loading) loading?.close()
  Message.error('请求失败')
  return Promise.reject(err)
})
Vue.prototype.ApiHttp = function (url, data, type = 'get',isFile=false) {
  let dflodading = true;
//console.log('myBaseUrl222222222',url)
  if (data && !data.isloading){
  	dflodading = false;
  	delete data.isloading;
  }
  if (type == 'get') {
    let paramStr = '';
    for (let keys in data) {
      if (data[keys] == null || data[keys] == undefined) data[keys] = '';
      paramStr = paramStr + keys + '=' + data[keys] + '&';
    }
    if (paramStr) {
      paramStr = paramStr.substring(0, paramStr.length - 1);
      url = url + '?' + paramStr;
    }
  }
  let sendObject = {
		url:url,
	    method: type,
	    headers: {
	        'Content-Type': 'application/json;charset=UTF-8'
	    },
    	data: data,
    	isloading: dflodading,
	};
	if(isFile){
		sendObject.headers={
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	}
  //请求数据
  console.log('123sendInfo',sendObject)
  return service(sendObject);
};


export default {
  get(url, params) {
    return service.get(url, { params })
  },
  post(url, data) {
    return service.post(url, data)
  },
  put(url, data) {
    return service.put(url, data)
  },
  delete(url, params) {
    return service.delete(url, { params })
  }
}